<template>
  <b-input-group class="mb-3">
    <b-form-input
      :id="name+ _uid"
      type="text"
      :name="name"
      v-model="date_"
      required
      @input="$emit('input')"
      :state="valid"
      autocomplete="off"
      :disabled="disabled"
      :aria-describedby="name + '-live-feedback'">
    </b-form-input>
    <b-input-group-append>
      <b-form-datepicker
        v-bind="calendarSettings || {}"
        button-only
        right
        required
        @input="$emit('input')"
        :state="valid"
        :disabled="disabled"
        :date-format-options="formatOptions"
        @context="selectDate"
        :aria-controls="name + _uid"
      ></b-form-datepicker>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import syncProperty from '@/mixins/syncProperty'

export default {
  name: 'DatePicker',
  computed: {
    formatOptions () {
      return this.$config.calendar.formatter.formatterOptions.dateFormatOptions
    },
    calendarSettings () {
      return { ...this.$config.calendar.calendarSettings, ...this.calendarOptions }
    }
  },
  methods: {
    selectDate (ctx) {
      if (ctx.selectedDate) {
        this.date_ = ctx.selectedFormatted
      }
    }
  },
  mixins: [
    syncProperty('date', 'date_')
  ],
  props: {
    valid: {
      type: Boolean
    },
    name: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    calendarOptions: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
